
import axios from 'axios';
import { NotificationType } from '../controllers/messaging';
import { IUserRecord, LovenseCommand } from '../ts/Definitions';
import { LovensePresetName } from '../ts/enums';
import Emitter, { ShowQRCodeExplain } from './Emitter';
import { v4 } from 'uuid';

export const syncLovense = (control: IUserRecord) => {
    const { userid, username } = control;
    Emitter.emit(ShowQRCodeExplain);
    void fetchLovenseQRCode(userid, username).then((result) => {
        window.open(result.qr, '_blank');
    });
}

export const getLocation = async (): Promise<Record<string, string>> => {
    try {
        const ipRes = await axios.get('https://api.db-ip.com/v2/free/self');
        const { ipAddress } = ipRes.data;

        const res = await axios.get('https://ipapi.co/json/')
        const { city, region, country_name, longitude, latitude, ip } = res.data;

        return { city, region, country_name, longitude, latitude, ipAddress, ip }
    } catch {
        return {};
    }
}

export const pushLovense = async (payload: LovenseCommand): Promise<void> => {
    try {
        const result = await axios.post('https://api.lovense-api.com/api/lan/v2/command', {
            token: payload.token,
            uid: payload.uid,
            toy: payload.toy,
            command: payload.command,
            name: LovensePresetName[payload.name as LovensePresetName].toString(),
            timeSec: payload.timeSec,
            apiVer: payload.apiVer,
        });
        if (result.data) {
            if (result.data.code === 507) {
                Emitter.emitNotification({
                    message: 'Unable to contact Lovense App to perform action. Inform user, they must sync toy again for Tarlings to control',
                    error: true, notificationType: NotificationType.ErrorInfo
                });
            } else {
                if (result.data.code === 200) {
                    Emitter.emitNotification({
                        message: 'Successfully sent BUZZ to toy',
                        success: true, notificationType: NotificationType.ToyInfo
                    });
                    return;
                }
                Emitter.emitNotification({
                    message: `${result.data.code} ${result.data.message}`,
                    error: !result.data.result, notificationType: NotificationType.ErrorInfo
                });
            }
        }
    } catch (e) {
        console.error(e);
    }
}

const fetchLovenseQRCode = async (userid: string, username: string) => {
    const utoken = v4();
    const result = await axios.post(
        'https://api.lovense-api.com/api/lan/getQrCode',
        {
            token: import.meta.env.VITE_LOVENSE_API_KEY,
            uid: userid,
            uname: username,
            utoken,
            v: 2,
        }
    );
    return { ...result?.data?.data as { qr: string, code: string }, token: utoken };
}